const ITEMS = [
  "IT Support",
  "Excel & Data Solutions",
  "Automation",
  "Python Development",
  "Networking",
  "Word & PowerPoint",
  "Problem Solving",
  "Birmingham & West Midlands",
];

export default function Marquee() {
  return (
    <section className="overflow-hidden border-y border-cyan-500/10 bg-[#0A1128] py-5" data-testid="marquee-section" aria-hidden="true">
      <div className="marquee-track flex w-max whitespace-nowrap">
        {[0, 1].map((dup) => (
          <div key={dup} className="flex shrink-0 items-center">
            {ITEMS.map((item) => (
              <span key={`${dup}-${item}`} className="flex items-center">
                <span className="font-display text-lg font-medium tracking-wide text-slate-500">{item}</span>
                <span className="mx-8 font-mono text-cyan-500/50">{"//"}</span>
              </span>
            ))}
          </div>
        ))}
      </div>
    </section>
  );
}
